import { forwardRef } from "react";
import { Link as RLink, NavLink as RNavLink, useNavigate as useRNavigate } from "react-router-dom";
import { PL, PL_PATTERNS } from "./pl";
import { lp } from "./routes";

export { lp };
export const getLang = () => "pl";

export const Link = forwardRef(({ to, ...p }, ref) => <RLink ref={ref} to={lp(to)} {...p} />);
export const NavLink = forwardRef(({ to, ...p }, ref) => <RNavLink ref={ref} to={lp(to)} {...p} />);
export const useNavigate = () => { const nav = useRNavigate(); return (to, opts) => nav(lp(to), opts); };

let dict = PL;
export const setOverrides = (o) => { if (o && typeof o === "object") dict = { ...PL, ...o }; };

function tr(s) {
  const t = s.trim();
  if (!t) return null;
  let out = dict[t];
  if (!out) for (const [rx, rep] of PL_PATTERNS) if (rx.test(t)) { out = t.replace(rx, rep); break; }
  return out && out !== t ? s.replace(t, out) : null;
}
export const t = (s) => (typeof s === "string" ? tr(s) || s : s);

const ATTRS = ["placeholder", "aria-label", "title", "alt"];
function walk(node) {
  if (window.location.pathname.startsWith("/admin")) return;
  if (node.nodeType === 3) { const v = tr(node.nodeValue); if (v) node.nodeValue = v; return; }
  if (node.nodeType !== 1 || node.closest?.("[data-notranslate]") || node.tagName === "SCRIPT" || node.tagName === "STYLE") return;
  ATTRS.forEach((a) => { const v = node.getAttribute(a); if (v) { const x = tr(v); if (x) node.setAttribute(a, x); } });
  node.childNodes.forEach(walk);
}

export function startTranslator() {
  document.documentElement.lang = "pl";
  walk(document.body);
  new MutationObserver((muts) => muts.forEach((m) => {
    if (m.type === "characterData") walk(m.target);
    else if (m.type === "attributes") walk(m.target);
    else m.addedNodes.forEach(walk);
  })).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
}
